export class PsDocumentState {

    _id; // number
    _name; // string
    _color; // string

    constructor(
        id,
        name,
        color,
    ) {
        this._id = id;
        this._name = name;
        this._color = color;
    }

    static null() {
        return new this(
            -1,
            '',
            '',
        );
    }

    static fromAPIDocumentState(state) {
        return new this(
            state.id,
            state.name,
            state.color,
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    color() {
        return this._color;
    }

    data() {
        return {
            id: this._id,
            name: this._name,
            color: this._color,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/document/list/PsDocumentState.js